import { render, staticRenderFns } from "./CompeteTemplate.vue?vue&type=template&id=4ee34fbd&scoped=true&"
import script from "./CompeteTemplate.vue?vue&type=script&lang=js&"
export * from "./CompeteTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CompeteTemplate.vue?vue&type=style&index=0&id=4ee34fbd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee34fbd",
  null
  
)

export default component.exports